import React, { useState, useEffect } from 'react';
import {
  Box, Paper, Typography, Chip, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Alert, CircularProgress,
} from '@mui/material';
import SubscriptionService from '../../services/subscription.service';

const BillingHistory = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    SubscriptionService.getPayments()
      .then((data) => { if (active) setPayments(Array.isArray(data) ? data : []); })
      .catch((err) => {
        console.error('Error loading billing history:', err);
        if (active) setError('Failed to load billing history');
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <Box>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Paper>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Plan</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell>Type</TableCell>
                <TableCell align="center">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}><CircularProgress /></TableCell>
                </TableRow>
              ) : payments.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    <Typography color="text.secondary">No payments yet</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                payments.map((p) => (
                  <TableRow key={p.id} hover sx={{ '& td': { fontSize: '0.95rem' } }}>
                    <TableCell>{p.created_at ? String(p.created_at).slice(0, 10) : ''}</TableCell>
                    <TableCell>{p.plan_name}</TableCell>
                    <TableCell align="right">
                      <Typography fontWeight={600} fontSize="0.95rem">
                        {SubscriptionService.formatCurrency(p.amount, p.currency)}
                      </Typography>
                    </TableCell>
                    <TableCell>{p.auto_renewed ? 'Auto-renewal' : 'Manual'}</TableCell>
                    <TableCell align="center">
                      <Chip size="small" label={SubscriptionService.getStatusLabel(p.status)} color={SubscriptionService.getStatusColor(p.status)} />
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default BillingHistory;
